import { PricingTier } from "./components/PricingCard";

export const PER_SEAT_COST_USD = 49;
export const LIMITS = {
  PRO: 10000,
  PREMIUM: 25000,
};

export interface Testimonial {
  quoteId: string;
  quoteDefault: string;
  roleId: string;
  roleDefault: string;
  orgId: string;
  orgDefault: string;
}

export const TESTIMONIALS: Testimonial[] = [
  {
    quoteId: "billing.upgrade.testimonial.1.quote",
    quoteDefault:
      "From what I saw in the demonstration, this would take so much work off our adjusters that I don't think we'd need to hire another employee.",
    roleId: "billing.upgrade.testimonial.1.role",
    roleDefault: "Senior Manager",
    orgId: "billing.upgrade.testimonial.1.org",
    orgDefault: "Insurance Operations",
  },
  {
    quoteId: "billing.upgrade.testimonial.2.quote",
    quoteDefault:
      "What took 3 hours to complete in the past now takes minutes.",
    roleId: "billing.upgrade.testimonial.2.role",
    roleDefault: "Quality Assurance Specialist",
    orgId: "billing.upgrade.testimonial.2.org",
    orgDefault: "Quality Assurance",
  },
  {
    quoteId: "billing.upgrade.testimonial.3.quote",
    quoteDefault: "I have gone from days to hours.",
    roleId: "billing.upgrade.testimonial.3.role",
    roleDefault: "Medical File Reviewer",
    orgId: "billing.upgrade.testimonial.3.org",
    orgDefault: "Medical Records Review",
  },
  {
    quoteId: "billing.upgrade.testimonial.4.quote",
    quoteDefault:
      "Sky AI didn\u2019t replace our experts \u2014 it amplified them. The reports are faster, cleaner, and more defensible.",
    roleId: "billing.upgrade.testimonial.4.role",
    roleDefault: "Medical Director",
    orgId: "billing.upgrade.testimonial.4.org",
    orgDefault: "IME Services",
  },
  {
    quoteId: "billing.upgrade.testimonial.5.quote",
    quoteDefault:
      "We can now process complex, multi-thousand-page files and produce decision-ready reports in a fraction of the time.",
    roleId: "billing.upgrade.testimonial.5.role",
    roleDefault: "Director of Operations",
    orgId: "billing.upgrade.testimonial.5.org",
    orgDefault: "IME Provider",
  },
];

export const SHARED_FEATURES = [
  {
    id: "billing.upgrade.sharedFeature.allDocTypes",
    defaultMessage: "Docs, chats, reports & transcription",
  },
  {
    id: "billing.upgrade.sharedFeature.security",
    defaultMessage: "Enterprise-grade security",
  },
  {
    id: "billing.upgrade.sharedFeature.cancel",
    defaultMessage: "Cancel anytime",
  },
];

export const PRICING_TIERS: PricingTier[] = [
  {
    id: "flex",
    nameId: "billing.upgrade.plan.flex.name",
    nameDefault: "Flex",
    priceId: "billing.upgrade.plan.flex.price",
    priceDefault: "$0.12",
    unitId: "billing.upgrade.plan.flex.unit",
    unitDefault: "/page",
    subtitleId: "billing.upgrade.plan.flex.subtitle",
    subtitleDefault: "Pay-as-you-go, billed monthly",
    features: [
      {
        id: "billing.upgrade.plan.flex.feature1",
        defaultMessage: "A typical 500-page case costs ~$60",
      },
      {
        id: "billing.upgrade.plan.flex.feature2",
        defaultMessage: "Rates decrease with volume",
      },
      {
        id: "billing.upgrade.plan.flex.feature3",
        defaultMessage: "All platform features included",
      },
    ],
    ctaId: "billing.upgrade.plan.flex.cta",
    ctaDefault: "Continue with Flex",
    highlighted: false,
    plan: "FLEX",
  },
  {
    id: "pro",
    nameId: "billing.upgrade.plan.pro.name",
    nameDefault: "Pro",
    priceId: "billing.upgrade.plan.pro.price",
    priceDefault: "$999",
    unitId: "billing.upgrade.plan.pro.unit",
    unitDefault: "/mo",
    subtitleId: "billing.upgrade.plan.pro.subtitle",
    subtitleDefault: "Predictable monthly budget",
    equivalentNoteId: "billing.upgrade.plan.pro.equivalentNote",
    equivalentNoteDefault: "Save 17% vs. pay-as-you-go",
    features: [
      {
        id: "billing.upgrade.plan.pro.feature1",
        defaultMessage: "~10,000 pages of processing included",
      },
      {
        id: "billing.upgrade.plan.pro.feature2",
        defaultMessage: "Overage at Flex rates",
      },
      {
        id: "billing.upgrade.plan.pro.feature3",
        defaultMessage: "All platform features included",
      },
    ],
    ctaId: "billing.upgrade.plan.pro.cta",
    ctaDefault: "Choose Pro",
    highlighted: true,
    badgeId: "billing.upgrade.plan.pro.badge",
    badgeDefault: "Most Popular",
    plan: "PRO",
  },
  {
    id: "premium",
    nameId: "billing.upgrade.plan.premium.name",
    nameDefault: "Premium",
    priceId: "billing.upgrade.plan.premium.price",
    priceDefault: "$2,199",
    unitId: "billing.upgrade.plan.premium.unit",
    unitDefault: "/mo",
    subtitleId: "billing.upgrade.plan.premium.subtitle",
    subtitleDefault: "Predictable, scalable solution",
    equivalentNoteId: "billing.upgrade.plan.premium.equivalentNote",
    equivalentNoteDefault: "Save 27% vs. pay-as-you-go",
    features: [
      {
        id: "billing.upgrade.plan.premium.feature1",
        defaultMessage: "~25,000 pages of processing included",
      },
      {
        id: "billing.upgrade.plan.premium.feature2",
        defaultMessage: "Overage at Flex rates",
      },
      {
        id: "billing.upgrade.plan.premium.feature3",
        defaultMessage: "All platform features included",
      },
    ],
    ctaId: "billing.upgrade.plan.premium.cta",
    ctaDefault: "Get Premium",
    highlighted: false,
    plan: "PREMIUM",
  },
];
